import classes from './SystemMessage.module.css'


function SystemMessage(params) {
    return (
        <div className={classes.SystemMessageContainer}>
            <div className={classes.SystemMessage}>
                {params.text}
            </div>
        </div>
    );
}

export default SystemMessage;